import React, { useEffect, useRef, useState } from "react";

import { withTranslation } from "react-i18next";

import NoAccessTitle from "../no-access-title/no-access-title";
import { TabContextMenu } from "./context-menu/context-menu";
import hasPermission from "../../utils/hasPermissions";

import "./custom-tabs.scss";
import { NavItem, TabContent, TabPane } from "reactstrap";
import { Tabs, TabsNavItem } from "components/tabs";

interface ITab {
    name: string;
    hide?: boolean;
    permCode?: string;
    tabContent: any;
}

interface ISingleCustomTabs {
    tab: ITab;
    className?: string;
    notTranslated?: boolean;
    t: any;
    refWrapper?: any;
    disabled?: boolean;
    contentClassName?: string;
    disableFullscreen?: boolean;
    children?: Children;
}

const SingleCustomTab = (props: ISingleCustomTabs) => {
    let { tab, t, className, notTranslated, refWrapper, contentClassName, disableFullscreen = false, children } = props;

    const [isFullscreen, setIsFullscreen] = useState<boolean>(false);

    // Code to display context menu START
    const [contextMenuOpen, setContextMenuOpen] = useState<boolean | undefined>(false);
    const [position, setPosition] = useState<{ x: number; y: number }>({ x: 0, y: 0 });

    const tabRef = useRef<any>(null);

    useEffect(() => {
        const handleOutsideClick = (e) => {
            if (tabRef.current && !tabRef.current.contains(e.target)) {
                setContextMenuOpen(false);
            }
        };

        const eventTypes = ["contextmenu", "click"];
        eventTypes.forEach((eventType) => {
            document.addEventListener(eventType, handleOutsideClick);
        });

        return () => {
            eventTypes.forEach((eventType) => {
                document.removeEventListener(eventType, handleOutsideClick);
            });
        };
    }, []);

    const handleTabContextMenu = (e) => {
        e.preventDefault();
        const position = e.target.getBoundingClientRect();
        setPosition({ x: e.pageX - position.x, y: e.pageY - position.y });
        setContextMenuOpen(true);
    };

    // Code to display context menu END
    const handleFullScreen = () => setIsFullscreen((prev) => !prev);

    if (!!tab.hide) return <></>;
    if (tab.permCode && !hasPermission(tab.permCode)) return <NoAccessTitle />;

    return (
        <div className={`tabs-container ${className ? className : ""} ${isFullscreen ? "fullscreen" : ""}`}>
            <div className="tabs-nav">
                <Tabs ref={tabRef}>
                    <div>
                        {contextMenuOpen && (
                            <TabContextMenu
                                isFullscreen={isFullscreen}
                                onFullScreen={!disableFullscreen && handleFullScreen}
                                setContextMenuOpen={setContextMenuOpen}
                                permCode={tab.permCode}
                                position={position}
                            />
                        )}
                        <TabsNavItem
                            key={`tabs-nav-${tab.name}`}
                            isActive
                            disabled={props.disabled}
                            onDoubleClick={!disableFullscreen && handleFullScreen}
                            onContextMenu={(e) => handleTabContextMenu(e)}
                        >
                            {notTranslated ? tab.name : t(tab.name)}
                        </TabsNavItem>
                    </div>
                </Tabs>
                <div className="tabs-filler" />
                {children}
            </div>
            <div ref={refWrapper} className={`tabs-content ${contentClassName ? contentClassName : ""}`}>
                {tab.tabContent}
            </div>
        </div>
    );
};

export default withTranslation()(SingleCustomTab);
